import React from 'react';
import './FeatureStyles.css';

const ConversationalExplorationVideo = () => (
  <div className="feature-animation" style={{ outline: '1px solid #e5e7eb' }}>
    <video
      autoPlay
      loop
      muted
      playsInline
      style={{ filter: 'brightness(1.05)' }}
    >
      <source src="/conversational.mp4" type="video/mp4" />
    </video>
  </div>
);

const ConversationalExplorationFeature = {
  icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="10" r="3" />
      <path d="M12 13v2" />
    </svg>
  ),
  title: "Real Conversational Test Creation & App Exploration",
  description: "No AI hidden behind the scenes. Interact directly with AI while using your app - chat, command, and collaborate in real-time. Say 'explore the checkout flow' or 'test login with invalid credentials' and watch AI navigate alongside you, creating comprehensive tests through genuine conversation.",
  animation: <ConversationalExplorationVideo />
};

export default ConversationalExplorationFeature;
